import {useEffect} from "react";
import {isDesktop} from "@/Helpers/Function";

export default function useScrollHeader() {
    useEffect(() => {
        const onScroll = () => {
            const headerClassName = 'header--sticky';
            const site = document.getElementById('site');
            const headerId = isDesktop() ? document.getElementById('header') : null;
            const initialHeaderHeight = 112; // Начальная высота header в px
            const stickyHeaderHeight = 72; // Высота header после фиксации
            const scrollHeight = 112 // высота прокрутки в px после которой header фиксируется

            if (headerId !== null) {
                // if (window.scrollY > scrollHeight && document.body.clientHeight - (difference + scrollHeight) > window.innerHeight) {
                if (window.scrollY > scrollHeight) {
                    headerId.classList.add(headerClassName);
                    site.style.paddingTop = `${initialHeaderHeight - stickyHeaderHeight}px`;
                } else {
                    headerId.classList.remove(headerClassName);
                    site.style.paddingTop = '0px';
                }
            }

            const backToTop = document.getElementById('backToTop');
            const backToTopClassName = 'backToTop--visible';
            if (backToTop !== null) {
                if (window.scrollY > scrollHeight) {
                    backToTop.classList.add(backToTopClassName);
                } else {
                    backToTop.classList.remove(backToTopClassName);
                }
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
}
